import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomePage.vue';
import Login from '../views/WmsLogin.vue';
import receivingScan from '../views/master/ReceivingScanMaster.vue';
import warehouseDashboard from '@/views/master/WarehouseDashboard.vue';
import poOverview from '@/views/master/PoOverview.vue';
import dailyDemand from '@/views/master/DailyDemand.vue';
import invoiceIssuance from '@/views/master/InvoiceIssuance.vue';
import orderStatus from '@/views/master/OrderStatus.vue';
import packingHistory from '@/views/master/PackingHistory.vue';
import supplyPerformance from '@/views/master/SupplyPerformance.vue';
import materialMain from '@/views/master/MaterialMain.vue';
import materialScan from '@/views/master/MaterialScan.vue';
import scanHistory from '@/views/master/ScanHistory.vue';
import Notice from '@/views/master/Notice.vue';
import store from '@/store/index';
import axios from 'axios';
const routes = [
    {
        path: '/',
        component: Home,
        meta: { requiresAuth: true, isLoginPage: false } // 로그인이 필요한 페이지
    },
    {
        path: '/login',
        component: Login,
        meta: { isLoginPage: true, requiresAuth: false }
    },
    {
        path: '/notice',
        component: Notice,
        meta: { requiresAuth: true, requiresSeohan: true }
    },
    {
        path: '/warehouseDashboard',
        component: warehouseDashboard,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    
    {
        path: '/receivingScan',
        component: receivingScan,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    {
        path: '/poOverview',
        component: poOverview,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    {
        path: '/dailyDemand',
        component: dailyDemand,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    {
        path: '/invoiceIssuance',
        component: invoiceIssuance,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    {
        path: '/orderStatus',
        component: orderStatus,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    {
        path: '/packingHistory',
        component: packingHistory,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    {
        path: '/supplyPerformance',
        component: supplyPerformance,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    {
        path: '/materialMain',
        component: materialMain,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    {
        path: '/materialScan',
        component: materialScan,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    {
        path: '/scanHistory',
        component: scanHistory,
        meta: { requiresAuth: true, isLoginPage: false} // 로그인이 필요한 페이지
    },
    // 기타 라우트
];

const router = createRouter({
    history: createWebHistory(), // 웹 히스토리 모드 사용
    routes, // 라우트 설정
});

router.beforeEach(async (to, from, next) => {
    // 'requiresAuth' 메타 필드를 체크하여 로그인 필요 여부 결정
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // 여기서 세션 체크 로직 구현 (예: API 요청 또는 상태 관리)
        const response = await axios.get('/api/session-status');
        //console.log('here', response)
        const check = response.data.loggedIn;
        //console.log('hi', check)
        if (!check) { // sessionUserExists는 세션 상태 확인 함수
            next('/login'); // 세션 정보가 없으면 로그인 페이지로 리디렉션
        } else {
            store.commit('setUsername', response.data.username)
            store.commit('setUserFullName', response.data.userName)

            if (to.matched.some(record => record.meta.requiresSeohan) &&
                (typeof response.data.username !== 'string' || response.data.username.toUpperCase() !== 'SEOHAN')) {
                next('/');
                return;
            }

            next(); // 세션 정보가 있으면 요청된 페이지로 이동
        }
    } else {
        next(); // 'requiresAuth'가 없는 페이지는 항상 허용
    }
});



export default router;
